<template>
  <div id="consult">
    <myhead></myhead>
    <div class="bar">
      <router-link to="/">Fountain-scientific Home Page</router-link>
      <span>></span>
      <router-link to="/consult">Online Customer Service</router-link>
    </div>
    <div class="con">
      <div class="consult">
        <p>Please contact: Fountain Scientific</p>
        <p>Phone: +86 18933991306</p>
        <p>Wechat: Choi-HongNeng</p>
        <p>Tel: +86 020 26220985</p>
        <p>Fax: +86 020 26220985</p>
        <p>E-mail: info@fountain-scientific.com, mahone.cai@fountain-scientific.com</p>
        <p>Address: Room C-103, No. 8, Hefeng 3rd Street, Huangpu District, Guangzhou City</p>
        <p>Business Hours: 9:00 a.m. to 6:00 p.m. (except Saturdays, Sundays, holidays and our company's closed days)</p>
        <p>If it is not our working day, please send us massage and we will come back to you as soon sa possible. We are all happy to help. </p>
        <!-- <p>各种咨询：未登载商品、询价、订购、售后、技术咨询、客户登记</p>
        <p>&nbsp;&nbsp;&nbsp;请联系：<span class="f-weight">热泉科技客服中心</span></p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话：020-26220985</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮件：info@yechine.com</p>
        <p>企业地址: 广州市黄埔区禾丰三街8号C103室</p>
        <p class="slogan">我们将 <span class="f-red">迅速 准确 认真</span> 为宗旨</p>
        <p>营业时间：上午9点-下午6点(周六日,节假日,我公司停业日除外)</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import myhead from "./common/header.vue";
import axios from "axios";
const url = require("../url").url;


export default {
  name: "Consult",
  components: {
    myhead
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted () {
    axios
      .get(url.contact)
      .then(response => {
        
        console.log(response.data);
      })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../assets/css/style.less");

.bar{
  height: 30px;
  line-height: 30px;
  text-align: left;
  font-size: 14px;
  padding: 0 10%;
  margin: 20px 0;
}
.bar>span{
  margin: 0 10px;
}
.con{
  padding: 0 10%;
}
.consult{
  font-size: 15px;
  text-align: left;
  box-sizing: border-box;
  background: url("../assets/imgs/consult.png") no-repeat;
  background-position: bottom right;
  /* height: 350px; */
  background-color: #eeeeee;
  padding: 50px 40px;
}
.consult>p{
  margin-bottom: 20px;
}
.f-weight{
  font-size: 16px;
  font-weight: 600;
}
.f-red{
  font-weight: 600;
  color: @indexTheme; 
}
.slogan{
  font-size: 18px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/consult.vue